var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.00013,
    cy: 6.7,
    r: 2.53333,
    stroke: "#424895"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 15.095L2.75629 10.8762C1.9174 10.0423 1.34645 8.98012 1.11518 7.82422C0.883901 6.66834 1.00258 5.47022 1.45633 4.38122C1.9101 3.2922 2.67872 2.36091 3.66545 1.70548C4.65223 1.05002 5.81266 0.699997 7 0.699997C8.18734 0.699997 9.34777 1.05002 10.3345 1.70548C11.3213 2.36091 12.0899 3.2922 12.5437 4.38122C12.9974 5.47022 13.1161 6.66834 12.8848 7.82422C12.6535 8.98012 12.0826 10.0423 11.2437 10.8762L7 15.095Z",
    stroke: "#424895"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerMobile);
export default __webpack_public_path__ + "static/media/marker-mobile.64be2cfade10b17a498b76b17d92b60e.svg";
export { ForwardRef as ReactComponent };